import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  fieldset: {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0
  },
  legend: {
    padding: 0,
    marginBottom: theme.spacing(2),
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: theme.colorPalette.beige_90
  },
  formControl: {
    width: '100%'
  },
  // One card per choice, as in the prototype.
  choices: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '& [class*="MuiFormControlLabel-root"]': {
      margin: 0,
      padding: theme.spacing(2, 3),
      border: `1px solid ${theme.colorPalette.beige_60}`,
      borderRadius: theme.sizes.innerCorners,
      backgroundColor: theme.colorPalette.white
    }
  },
  choiceLabel: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.colorPalette.green_100
  },
  policyId: {
    display: 'block',
    fontSize: 13,
    fontWeight: 400,
    fontVariantNumeric: 'tabular-nums',
    color: theme.colorPalette.beige_90
  }
});

export default makeStyles(styles);
